import { useEffect, useState } from 'react'
import { useAppStore } from '@/shared/store'

export const useProfileScreenModal = (
    shouldShowModal: boolean,
    setShouldShowModal?: (value: boolean) => void
) => {
    const [isModalOpen, setIsModalOpen] = useState(false)

    const handleSetIsModalOpen = (value: boolean) => {
        setIsModalOpen(value)
        setShouldShowModal && setShouldShowModal(value)
    }

    const { profiles, setProfiles, actualProfile, setActualProfile } =
        useAppStore()

    useEffect(() => {
        setIsModalOpen(shouldShowModal)
    }, [shouldShowModal])

    useEffect(() => {
        if (isModalOpen) {
            setShouldShowModal && setShouldShowModal(false)
        }
    }, [actualProfile?.profile_name, shouldShowModal])

    return {
        isModalOpen,
        handleSetIsModalOpen,
        actualProfile,
        setIsModalOpen,
        profiles,
        setProfiles,
        setActualProfile,
    }
}
